const book = (intl, methodName) => ({
  title: intl.formatMessage({ id: 'cms.book.name' }),
  'brand id': intl.formatMessage({ id: 'cms.brand' }),
  chapters: intl.formatMessage({ id: 'cms.book.chapter' }),
  'chapters.pages': intl.formatMessage({ id: 'cms.book.chapter.page' }),
  'chapters.pages.title': intl.formatMessage({ id: 'name' }),
  'chapters.pages.link_blocks': intl.formatMessage({ id: 'cms.linkBlock' }),
  'chapters.pages.link_blocks.links': intl.formatMessage({ id: 'cms.link' }),
  'chapters.pages.link_blocks.links.title': intl.formatMessage({ id: 'cms.link.name' }),
  'chapters.pages.link_blocks.links.link_type': intl.formatMessage({ id: 'cms.link.type' }),
  'chapters.pages.link_blocks.links.link_url': intl.formatMessage({ id: 'cms.link.path' }),
  'chapters.pages.link blocks.is footer': intl.formatMessage({
    id: 'cms.linkBlock.appPage.footer',
  }),
  'chapters.pages.metas': intl.formatMessage({ id: 'cms.book.chapter.page.meta.optional' }),
  'chapters.pages.metas.key': intl.formatMessage({ id: 'cms.book.chapter.page.meta.title' }),
  'chapters.pages.metas.value': intl.formatMessage({
    id: 'cms.book.chapter.page.meta.description',
  }),
  image: intl.formatMessage({ id: 'cms.book.chapter.page.imageAndVideo.alwaysOnTop.type.image' }),
  ...(methodName => {
    switch (methodName) {
      default:
        return {};
    }
  })(methodName),
});

export default book;
